// extracted by mini-css-extract-plugin
module.exports = {"plan":"Plan_plan__2AwXH","logo":"Plan_logo__1rvJg","months":"Plan_months__JlIXC","amount":"Plan_amount__5F0r6","free":"Plan_free__OdaRx","total":"Plan_total__32men"};